import { adminHttpClient } from '../adminHttpClient'
import { httpClient } from '../httpClient'

const getUploadSignedUrl = (fileName: string): Promise<any> => adminHttpClient.get(`/files/upload/${fileName}`)

export const uploadFile = async (file: File) => {
  const preSignedUrl = await getUploadSignedUrl(file.name)
  await httpClient.put(preSignedUrl.signedUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  })
  return Promise.resolve({
    fileId: preSignedUrl.objectKey,
  })
}
